define( [ 'jquery', 'jquery.validate.unobtrusive' ], function run( $, unobtrusive ) {
	'use strict';

	if ( !unobtrusive.destroy ) {
		unobtrusive.destroy = function destroy( $el ) {
			$el
				.off( '.validate' )
				.off( '.unobtrusiveValidation' )
				.removeData( 'unobtrusiveValidation' )
				.removeData( 'validator' );
			return this;
		};
	}

	// Custom defaults
	unobtrusive.options = {};

	/*
	 * Unobtrusive parses the document as soon as the DOM is ready - that may have
	 * already happened by the time we get here. Update the stored settings in
	 * with the new defaults
	 */

	$( 'form' ).each( function loop( idx, el ) {
		var validator = $( el ).data( 'validator' );
		if ( validator ) {
			validator.settings = $.extend({}, validator.settings, unobtrusive.options );
		}
	});

	return unobtrusive;
});
